export const LICENSE_SCOPES = ['pro', 'premium'];